// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "A sliding-scale that encourages users to guess at a value, then compares that guess with reality and the guesses of others.";
const CONFIG: InteractivesMenuItemConfig = {
  cradleIframeUrlRoot:"https://www.smh.com.au/interactive/2019/guesstimator/?resizable=true",
  // cradleIframeUrlRoot:"https://www.smh.com.au/interactive/tests/guesstimator/?resizable=true",
  name: "Guesstimator",
  id: "guesstimator",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Data viz", "Configurable", "Recorded input"],
  description,
  image: DisplayImage,
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "GuesstimatorConfigTool" */ "app/components/tools/GuesstimatorConfigTool/GuesstimatorConfigTool"),
    loading: DynamicImportLoader,
    modules: ["GuesstimatorConfigTool"]
  })
};

export default CONFIG;
